import { CommanderActionDef } from "./redemptionActions";

/**
 * Operations TAT (New Operations TAT) dashboard actions.
 * `action_id` keys are stable; `name` / `description` are what GA users read.
 */
export const OPS_TAT_ACTIONS = {
  dashboard_view: {
    name: "View Operations TAT",
    description:
      "User opened Operations TAT and loaded cycle time, stages, and inward summary",
  },
  filter_apply: {
    name: "Apply Filters",
    description:
      "User clicked Apply / Search and refreshed Operations TAT with current filters",
  },
  filter_clear: {
    name: "Clear Filters",
    description:
      "User cleared Operations TAT filters back to defaults (path kept)",
  },
  dashboard_refresh: {
    name: "Refresh Dashboard",
    description:
      "User clicked Refresh to reload Operations TAT with the already applied filters",
  },
  drilldown_refresh: {
    name: "Refresh Card",
    description:
      "User clicked Refresh inside an open Ops TAT card to reload it with applied filters",
  },
  date_preset_select: {
    name: "Select Date Preset",
    description:
      "User picked a quick date chip (Last 7 / 30 / 90 days, 6 months, or FY) and refreshed",
  },
  date_range_change: {
    name: "Pick Custom Dates",
    description:
      "User changed the custom date range in the draft filters (before Apply)",
  },
  search_panel_toggle: {
    name: "Toggle Search Panel",
    description: "User expanded or collapsed the Operations TAT Search panel",
  },
  filter_order_id_change: {
    name: "Change Order ID",
    description: "User changed order ID filter (draft, before Apply)",
  },
  filter_order_type_change: {
    name: "Change Order Type",
    description: "User changed order type filter (draft, before Apply)",
  },
  filter_project_poc_change: {
    name: "Change Project POC",
    description: "User changed Project POC filter (draft, before Apply)",
  },
  filter_sourcing_poc_change: {
    name: "Change Sourcing POC",
    description: "User changed Sourcing POC filter (draft, before Apply)",
  },
  filter_vendor_change: {
    name: "Change Vendor",
    description: "User changed vendor filter (draft, before Apply)",
  },
  filter_project_status_change: {
    name: "Change Project Status",
    description: "User changed Active/Archived/Both project status (draft)",
  },
  filter_excluded_orders_change: {
    name: "Change Excluded Orders",
    description:
      "User toggled excluded-from-sourcing orders in draft filters",
  },
  filter_include_running_change: {
    name: "Change Include Running",
    description:
      "User toggled include running orders in TAT calculations (draft)",
  },
  path_change: {
    name: "Change Path",
    description:
      "User switched Operations TAT path (All / Custom / Stock)",
  },
  drilldown_open: {
    name: "Open Metric Card",
    description:
      "User opened a clickable Ops TAT card (stage, headline, dispatch, or inward)",
  },
  drilldown_close: {
    name: "Close Metric Card",
    description: "User closed the Ops TAT card drilldown drawer",
  },
  drilldown_scope_change: {
    name: "Change Card Scope",
    description:
      "User switched Measured / Open / All scope inside an open card",
  },
  drilldown_sort: {
    name: "Sort Card Table",
    description: "User sorted a column inside an open Ops TAT card",
  },
  drilldown_page_change: {
    name: "Change Card Page",
    description: "User changed page inside an open Ops TAT card table",
  },
  drilldown_page_size_change: {
    name: "Change Card Rows Per Page",
    description: "User changed rows per page inside an open Ops TAT card",
  },
  export_csv: {
    name: "Export Card CSV",
    description: "User exported CSV for the currently open Ops TAT card",
  },
  formula_toggle: {
    name: "Toggle Formula Help",
    description:
      "User expanded or collapsed How this is calculated on an open card",
  },
  how_to_read_toggle: {
    name: "Toggle How To Read",
    description: "User expanded or collapsed a How to read help section",
  },
  vendor_page_change: {
    name: "Change Vendor Table Page",
    description:
      "User changed page on the inward deviation vendors table",
  },
} as const satisfies Record<string, CommanderActionDef>;

export type OpsTatActionId = keyof typeof OPS_TAT_ACTIONS;
